import { PaymentTransaction, PaymentRequest } from "@cruisen/contract"
import { formatCurrency } from "@cruisen/i18n"
import styles from "./styles.module.scss"
import successCheckImage from "../../../../assets/successCheck.png"
import classNames from "classnames"
import { PaymentInfoWrapper } from "../PaymentInfoWrapper"

export const QuoteSummary = ({
  paymentRequest,
  paymentTransaction,
  lineItemId,
}: {
  paymentRequest: PaymentRequest
  paymentTransaction: PaymentTransaction
  lineItemId: string
}) => {
  const lineItem = paymentRequest?.lineItems?.find((li) => li.id === lineItemId)
  const areTaxesAndFeesPresent = Number(lineItem?.taxesAndFees || 0) > 0

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.scrollContainer}>
          <div className={styles.header}>
            <img src={successCheckImage} alt="Success Check" className={styles.successImage} />
            <h2 className={styles.title}>Quote approved</h2>
          </div>

          <div className={styles.infoContainer}>
            <PaymentInfoWrapper
              paymentData={[
                {
                  label: "Transaction ID",
                  value: paymentTransaction?.id || "",
                },
                {
                  label: "Date",
                  value: new Date(paymentTransaction?.created).toLocaleDateString(),
                },
              ]}
            />

            <PaymentInfoWrapper
              paymentData={[
                {
                  label: "Payment method",
                  value:
                    paymentTransaction?.paymentMethodProvider === "creditCard"
                      ? "Credit card"
                      : "Bank account",
                },
                paymentTransaction?.paymentMethodProvider === "creditCard"
                  ? {
                      label: "Card number",
                      value: `ending in ${paymentTransaction?.paymentMethodDisplayName?.slice(-4)}`,
                    }
                  : {
                      label: "Account number",
                      value: `***${paymentTransaction?.paymentMethodDisplayName}`,
                    },
                lineItem?.paymentPlan && {
                  label: "Payment schedule",
                  value: lineItem?.paymentPlan,
                },
                {
                  label: "Payment status",
                  value: "",
                  status: paymentTransaction?.status,
                },
                lineItem?.deposit && {
                  label: "Deposit amount",
                  value: formatCurrency(Number(lineItem?.deposit), 2),
                },
              ].filter(Boolean)}
            />

            <PaymentInfoWrapper
              paymentData={[
                {
                  label: lineItem?.type === "cabinBooking" ? "Cabin fare" : "Price",
                  value: formatCurrency(Number(lineItem?.amount), 2),
                },
                areTaxesAndFeesPresent && {
                  label: "Taxes & fees",
                  value: formatCurrency(Number(lineItem?.taxesAndFees), 2),
                },
              ].filter(Boolean)}
            >
              <div className={styles.totalRow}>
                <div className={styles.divider} />
                <div className={styles.row}>
                  <div className={styles.label}>Total</div>
                  <div className={classNames(styles.value, styles.totalValue)}>
                    {formatCurrency(Number(lineItem?.total), 2)}
                  </div>
                </div>
              </div>
            </PaymentInfoWrapper>

            {paymentTransaction?.paymentMethodProvider === "creditCard" ? null : (
              <PaymentInfoWrapper
                paymentData={[
                  {
                    label: "You paid",
                    value: formatCurrency(Number(paymentTransaction?.amount), 2),
                  },
                ]}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
